"use client";

import IntroAnimation from "@/features/navigation/IntroAnimation";
import { HeroSection } from "@/features/landing-page/HeroSection";
import { FoodPanel } from "@/features/landing-page/FoodPanel";
import { HistoryPanel } from "@/features/landing-page/HistoryPanel";
import { EventsPanel } from "@/features/landing-page/EventsPanel";
import { useState, useRef } from "react";
import { TestimonialsPanel } from "@/features/landing-page/TestimonialsPanel";
import { ArticleSection } from "@/features/landing-page/ArticleSection";
import { LandingPage } from "@/features/landing-page/LandingPage";

const VerticalScrollContainer = () => {
  const container = useRef<HTMLDivElement>(null);

  return (
    <div ref={container} className="flex w-full flex-col bg-sand-100">
      <LandingPage />
      {/* <HeroSection />
      <ArticleSection />
      <TestimonialsPanel />
      <div className="contentContainer min-h-dvh w-full">
        <HistoryPanel />
        <FoodPanel />
        <EventsPanel />
      </div> */}
    </div>
  );
};

// const HorizontalScrollContainer = () => {
//   // TODO: Refactor HorizontalScrollContainer with independent panel components
//   // Similar to VerticalScrollContainer refactor
// };

export default function Home() {
  const [showIntro, setShowIntro] = useState(true);

  const handleIntroComplete = () => {
    setShowIntro(false);
  };

  return (
    <div className="min-h-screen">
      {/* {showIntro && <IntroAnimation onComplete={handleIntroComplete} />} */}
      <VerticalScrollContainer />
      {/* <HorizontalScrollContainer /> */}
    </div>
  );
}
